var $ = require('jquery');
var _ = require('lodash');

class Nav {
    constructor() {
        this.$openMenu = $('.js-menu-button');
        this.$closeMenu = $('.js-menu-close');

        this.$body = $('.js-body');
        this.$container = $('.container-wrapper');

        this.setupListeners();
    }

    setupListeners() {
        this.$openMenu.on('click', () => {
            this.toggleMenu();
        });

        $('.nav-menu').find('a.nav-link').on('click', () => {
            $('#content').find('.container').css('opacity', 0);
            setTimeout(() => {
                this.toggleMenu();
            }, 500);
        });

        this.$closeMenu.on('click', () => {
            this.toggleMenu();
        });
    }

    toggleMenu() {
        setTimeout(() => {
            this.$container.toggleClass('nav-menu-open');
        }, 25);
    }
}

module.exports = Nav;